import { render } from "./LanguageMulti.vue?vue&type=template&id=2f43849e"
import script from "./LanguageMulti.vue?vue&type=script&lang=js"
export * from "./LanguageMulti.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__